<template>
  <div>
    <transition name="slide-fade">
      <div class="modal" v-show="modalData.addable">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">查看凭证</h5>
              <button type="button" class="close" @click="closeClick">
                <i class="ki ki-close"></i>
              </button>
            </div>
            <div class="modal-body body_margin">
              <div
                class="image-input-wrapper image-input-default"
                :style="{
                  'background-image': `url('${eHandleImageURI(
                    modalData.url
                  )}')`,
                }"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div class="modal-backdrop" v-show="modalData.backdropShow"></div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "PictureCtrl",
  data() {
    return {};
  },

  mounted() {},
  watch: {},
  methods: {
    closeClick() {
      this.$emit("input", false);
    },
    eHandleImageURI(url) {
      let result = "";
      if (url) {
        result = process.env.VUE_APP_API_URL
          ? `${process.env.VUE_APP_API_URL}/` + url
          : url;
      } else {
        result = this.singleDefault;
      }

      return result;
    },
  },
  props: {
    modalData: Object,
  },
};
</script>

<style lang="scss" scoped>
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0 !important;
}
.modal-backdrop {
  transition: opacity 0.3s linear;
  opacity: 0.2;
}
.modal {
  display: block;
}
.modal-footer {
  justify-content: center;
  border-top: none;
  .close_ctrl {
    width: 150px;
    color: #fff;
  }
}
.image-input-default {
  background: #e6e6e6;
  display: inline-block;
  height: 100%;
  width: 100%;
  background: no-repeat;
  background-size: 100% 100%;
  min-height: 400px;
  min-width: 300px;
}
.image-input-dashed {
  border: 1px dashed #9e9e9e !important;
  position: relative;
}
.body_margin {
  .body_card {
    div {
      margin: 5px 0px;
    }
  }
}
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(-50px);
  opacity: 0;
}
.body_title {
  font-size: 16px;
  color: #101010;
}
</style>
